import { getCustomizationOptions } from '@va/dashboard/selectors/customization';
import { SettingsHeading } from '@va/dashboard/ui/pages';
import { GlobeIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { contributorRole } from '@va/standalone/shared/selectors';
import { Button, InputWithSubsection } from '@va/ui/design-system';
import { useSelector } from 'react-redux';
import useDomainBlacklistingCard from './useDomainBlacklistingCard';

export function DomainBlacklistingCard() {
  const translate = useTranslate();
  const isContributor = useSelector(contributorRole);
  const {
    blacklistedDomains,
    inputValue,
    onRemove,
    onSubmit,
    onChange,
    onSave,
    isLoading,
    isLoadingUpdateCall,
    successSubmit,
    formError,
    hasMadeChanges,
  } = useDomainBlacklistingCard();
  const { providerName, supportCenterDomain } = useSelector(getCustomizationOptions);

  return (
    <div className='flex flex-col gap-18px items-start'>
      <SettingsHeading
        title={translate('card.blackListing.title')}
        subText={translate('card.blackListing.blacklistingDescription')}
        tooltip={translate('card.blackListing.tooltip', { providerName, supportCenterDomain })}
      />
      <div className='flex flex-col gap-4 w-full'>
        <InputWithSubsection
          disabled={isContributor}
          infoTooltip={isContributor ? translate('tooltips.contributorRole') : undefined}
          isLoading={isLoading}
          onSubmit={onSubmit}
          onRemove={onRemove}
          listItems={!isLoading && blacklistedDomains ? blacklistedDomains : []}
          icon={<GlobeIcon color='#3C3C3C' />}
          itemsLabel={translate('card.blackListing.domain.items.label')}
          successSubmit={successSubmit}
          inputProps={{
            value: inputValue,
            onChange: onChange,
            placeholder: translate('card.blackListing.blackListingPlaceholder'),
            name: 'domainBlacklistingInput',
            label: translate('card.blackListing.domain.label'),
          }}
          error={formError}
        />
        {hasMadeChanges && (
          <Button
            disabled={isLoadingUpdateCall}
            className='w-full'
            onClick={onSave}
            text={translate('button.saveChanges')}
          />
        )}
      </div>
    </div>
  );
}
